import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=298c7de6&scoped=true&"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlans.vue?vue&type=style&index=0&id=298c7de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298c7de6",
  null
  
)

export default component.exports